import React from 'react';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';
import MapSection from '../components/contact/MapSection';
import FAQ from '../components/FAQ';
import { MessageCircle, Phone, Mail, MapPin, Clock, HeadphonesIcon } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-32 pb-24">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://images.unsplash.com/photo-1596526131083-e8c633c948d2?q=80&w=2070&auto=format&fit=crop"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent" />
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-blue-200 text-sm font-medium mb-6">
              <HeadphonesIcon className="w-4 h-4 mr-2" />
              We're here to help
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight">
              Let's Start a{' '}
              <span className="bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
                Conversation
              </span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-300">
              Whether you're exploring a program, planning corporate training, or looking
              for export guidance — our team responds within 24 hours.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/2349058681595"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-green-600 hover:bg-green-500 text-white font-medium transition-colors"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                Chat on WhatsApp
              </a>
              <a
                href="tel:+2349058681595"
                className="inline-flex items-center justify-center px-6 py-3 rounded-md border-2 border-white/30 text-white hover:bg-white/10 font-medium transition-colors"
              >
                <Phone className="mr-2 h-5 w-5" />
                Call +234 905 868 1595
              </a>
            </div>
          </div>

          {/* Quick contact cards */}
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {[
              { icon: Phone, label: 'Phone', value: '+234 905 868 1595' },
              { icon: Mail, label: 'Email', value: 'info@lsem.org.ng' },
              { icon: MapPin, label: 'Office', value: 'Lekki, Lagos' },
              { icon: Clock, label: 'Hours', value: 'Mon–Fri, 9AM–5PM' },
            ].map((c) => (
              <div
                key={c.label}
                className="rounded-xl bg-white/5 backdrop-blur border border-white/10 p-5 hover:bg-white/10 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center mb-3">
                  <c.icon className="h-5 w-5 text-blue-300" />
                </div>
                <div className="text-slate-400 text-xs uppercase tracking-wide">{c.label}</div>
                <div className="text-white font-semibold mt-1 text-sm">{c.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>

      <MapSection />
      <FAQ />
    </div>
  );
};

export default Contact;